import { useState } from "react";
import { Button, YesNoModal } from "../../../../../../components";

type Props = {
  disabled?: boolean;
  onClick?: () => void;
};

const DiscardButton = ({ disabled, onClick }: Props) => {
  const [showDiscard, setShowDiscard] = useState(false);

  const closeDiscardModal = () => {
    setShowDiscard(false);
  };

  const handleDiscard = () => {
    onClick?.();
    closeDiscardModal();
  };

  return (
    <>
      <Button
        data-testid="layout-discard-button"
        disabled={disabled}
        variant="secondary"
        onClick={() => {
          setShowDiscard(true);
        }}
      >
        DISCARD
      </Button>
      <YesNoModal
        buttonLabels={{ yes: "DISCARD", no: "CANCEL" }}
        destructiveAction
        show={showDiscard}
        title="Discard Changes"
        onClickNo={closeDiscardModal}
        onClickYes={handleDiscard}
      >
        <span>Are you sure you want to discard made changes?</span>
      </YesNoModal>
    </>
  );
};

export default DiscardButton;
